import React from "react";
import { arrayOf, exact, number, shape, string } from "prop-types";
import styles from "./CoachStatisticsView.module.styl";
import CoachStatisticsRow from "components/coachStatistics/CoachStatisticsRow/CoachStatisticsRow";
import { Card } from "uikit/components";

export default function CoachStatisticsView({ coachesStatistics, pageSize, pageNumber }) {
    return (
        <Card
            borderRadius={"giant"}
            padding={"none"}
            className={styles.form}
            name="coach_statistics_view"
        >
            <div className={styles.headingContainer}>
                <div className={styles.coach}>Тренер</div>
                <div className={styles.coachStatistics}>
                    <div className={styles.subHeaderContainer}>
                        <div className={styles.subHeader}>Журнал учета спортивной подготовки</div>
                    </div>
                    <div className={styles.headerRow}>
                        <div>Заполнение планов тренировок</div>
                        <div>Заполнение журналов тренировок</div>
                        <div>Заполнение результатов соревнований</div>
                    </div>
                </div>
                <div className={styles.coachRatingPercentage}>
                    Сводный показатель работы в системе
                </div>
            </div>
            <div>
                {coachesStatistics?.map((item, i) => (
                    <CoachStatisticsRow
                        key={item.coachId}
                        coachStatistics={item}
                        index={i + 1 + (pageNumber - 1) * pageSize}
                    />
                )) ?? []}
            </div>
        </Card>
    );
}

CoachStatisticsView.propTypes = {
    coachesStatistics: arrayOf(
        shape({
            coachId: number.isRequired,
            coachName: exact({
                lastName: string.isRequired,
                firstName: string.isRequired,
                middleName: string,
                shortName: string.isRequired,
                fullName: string.isRequired,
                officialShortName: string.isRequired,
                officialFullName: string.isRequired,
                lastNameAndInitials: string.isRequired,
                firstNameAndMiddleName: string.isRequired,
            }),
            coachSex: string.isRequired,
            trainingsWithPlanFilledPercentage: number,
            trainingsWithPresenceFilledPercentage: number,
            competitionsWithResultsFilledPercentage: number,
            coachRatingPercentage: number,
        }),
    ).isRequired,
    pageSize: number.isRequired,
    pageNumber: number.isRequired,
};
